// Auto-generated by scripts/generate-coin-icon-manifest.ts — do not edit manually.
// Regenerate with: bun run generate:coin-icons

export const SYNCED_COIN_ICONS = new Set<string>([
	"$based",
	"$read",
	"$snow",
	"0xbtc",
	"10set",
	"1flr",
	"1inch",
	"1st",
	"4token",
	"aave",
	"abat",
	"abbc",
	"abt",
	"abusd",
	"ac3",
	"aca",
	"act",
	"ada",
	"adai",
	"adb",
	"adi",
	"adx",
	"ae",
	"aenj",
	"aeon",
	"aergo",
	"aeth",
	"agi",
	"aidoge",
	"aion",
	"aioz",
	"ait",
	"aknc",
	"akro",
	"akt",
	"alcx",
	"alend",
	"aleph",
	"aleth",
	"algo",
	"ali",
	"alink",
	"alis",
	"alpha",
	"altcoin",
	"alusd",
	"alx",
	"amana",
	"amb",
	"amkr",
	"amkt",
	"amlt",
	"amp",
	"ampl",
	"anc",
	"anj",
	"ankr",
	"ant",
	"ape",
	"aph",
	"apl",
	"appc",
	"apt",
	"apw",
	"apx",
	"apy",
	"ar",
	"arb",
	"arbs",
	"archive",
	"ardr",
	"aren",
	"ark",
	"arkm",
	"armor",
	"arn",
	"aro",
	"arrr",
	"asm",
	"asnx",
	"ast",
	"aster",
	"astro",
	"asusd",
	"atmi",
	"atom",
	"atusd",
	"auc",
	"audio",
	"aura",
	"ausdc",
	"ausdt",
	"auto",
	"avax",
	"avinoc",
	"avnt",
	"awbtc",
	"awc",
	"aweth",
	"axl",
	"axp",
	"axs",
	"ayfi",
	"azero",
	"azrx",
	"babydoge",
	"bac",
	"badger",
	"bal",
	"bam",
	"band",
	"bao",
	"based",
	"bat",
	"bay",
	"bbr",
	"bcap",
	"bcd",
	"bch",
	"bcha",
	"bcn",
	"bco",
	"bdx",
	"beam",
	"bel",
	"beta",
	"bf",
	"bfc",
	"bgb",
	"bico",
	"bifi",
	"bio",
	"birb",
	"bit",
	"bit-2",
	"bitcoin",
	"bix",
	"blank",
	"bld",
	"blk",
	"block",
	"blt",
	"blue",
	"blur",
	"blz",
	"bmda",
	"bnb",
	"bnc",
	"bnt",
	"bnx",
	"bob",
	"bond",
	"bond-2",
	"bondly",
	"bora",
	"botto",
	"box",
	"bpt",
	"bqx",
	"br",
	"brd",
	"brise",
	"brock",
	"bsb",
	"bsw",
	"btc",
	"btc++",
	"btcd",
	"btcp",
	"btg",
	"btmx",
	"bto",
	"btr",
	"bts",
	"btt",
	"btu",
	"bu",
	"bunny",
	"busd",
	"bwajna",
	"bwt",
	"bz",
	"bznt",
	"bzrx",
	"c20",
	"c98",
	"cake",
	"canto",
	"cap",
	"capp",
	"car",
	"card",
	"cbat",
	"cbc",
	"cbeth",
	"cbt",
	"cc",
	"cccx",
	"cdai",
	"cdt",
	"ceek",
	"cel",
	"celo",
	"celr",
	"cennz",
	"cet",
	"ceth",
	"cfg",
	"cfx",
	"chai",
	"chain",
	"chat",
	"chia",
	"cho",
	"chr",
	"chsb",
	"chz",
	"cirus",
	"ckb",
	"clo",
	"cloak",
	"clout",
	"cmt",
	"cnc",
	"cnd",
	"cnx",
	"coc",
	"cocn",
	"comai",
	"comp",
	"coni",
	"core",
	"cosm",
	"coti",
	"cov",
	"cova",
	"cover",
	"cpc",
	"cpx",
	"crd",
	"cre",
	"cre-2",
	"cream",
	"cred",
	"crep",
	"cro",
	"crpt",
	"crv",
	"crvusd",
	"cs",
	"csai",
	"csc",
	"cspr",
	"ctc",
	"ctsi",
	"ctxc",
	"cube",
	"cusdc",
	"cv",
	"cvc",
	"cvp",
	"cvt",
	"cvx",
	"cwbtc",
	"cyber",
	"czrx",
	"d2",
	"dadi",
	"dafi",
	"dag",
	"dai",
	"dao",
	"dasc",
	"dash",
	"dat",
	"data",
	"datx",
	"dbc",
	"dcb",
	"dcc",
	"dck",
	"dcn",
	"dcr",
	"dct",
	"ddd",
	"del",
	"dent",
	"dep",
	"deri",
	"deso",
	"dexe",
	"dexe-2",
	"df",
	"dfi",
	"dft",
	"dfyn",
	"dgb",
	"dgd",
	"dgtx",
	"dht",
	"dia",
	"dinero",
	"divi",
	"dlt",
	"dmt",
	"dmtr",
	"dnt",
	"dock",
	"dodo",
	"doge",
	"dogs",
	"dojo",
	"dome",
	"dor",
	"dot",
	"drgn",
	"drop",
	"dta",
	"dtr",
	"dtx",
	"duck",
	"dvf",
	"dxd",
	"dxt",
	"dydx",
	"eco",
	"edg",
	"edo",
	"edu",
	"efi",
	"efx",
	"egld",
	"egld2",
	"egt",
	"ekg",
	"ekt",
	"ela",
	"elan",
	"elec",
	"elf",
	"elg",
	"emc",
	"emc2",
	"ena",
	"eng",
	"enix",
	"enj",
	"ens",
	"ents",
	"eos",
	"eosdac",
	"eqb",
	"erg",
	"ern",
	"esd",
	"esp",
	"ess",
	"etc",
	"eth",
	"ethw",
	"etn",
	"etp",
	"etz",
	"euroc",
	"ever",
	"evmos",
	"evx",
	"ewt",
	"exrn",
	"exy",
	"ezy",
	"fab",
	"fame",
	"farm",
	"fct",
	"fdusd",
	"feed",
	"fei",
	"fet",
	"fida",
	"fidu",
	"fil",
	"filda",
	"fis",
	"flash",
	"flex",
	"floki",
	"flow",
	"flr",
	"flux",
	"fnsa",
	"foam",
	"fold",
	"fota",
	"fox",
	"fpi",
	"fpis",
	"frax",
	"frm",
	"front",
	"frxeth",
	"fsn",
	"fst",
	"ft",
	"ftc",
	"ftm",
	"ftt",
	"fuel",
	"fun",
	"fx",
	"fxc",
	"fxs",
	"fxt",
	"gal",
	"gala",
	"gamma",
	"gb",
	"gdc",
	"gem",
	"gen",
	"gho",
	"giv",
	"glmr",
	"gmee",
	"gmt",
	"gmt-2",
	"gmx",
	"gno",
	"gns",
	"gnt",
	"gnx",
	"go",
	"goc",
	"got",
	"govi",
	"grail",
	"grin",
	"grow",
	"grp",
	"grs",
	"grt",
	"gsc",
	"gswap",
	"gt",
	"gtai",
	"gtc",
	"gtc-2",
	"gto",
	"gusd",
	"gvt",
	"gxs",
	"gyen",
	"h",
	"hair",
	"hakka",
	"han",
	"hanep",
	"hav",
	"hbar",
	"hc",
	"heart",
	"hedg",
	"hegic",
	"her",
	"hex",
	"hft",
	"high",
	"hive",
	"hnt",
	"hot",
	"hot-x",
	"hpb",
	"hsr",
	"ht",
	"hum",
	"husd",
	"hvn",
	"hxro",
	"hydro",
	"hyn",
	"hype",
	"hzn",
	"ibat",
	"ice",
	"icn",
	"icp",
	"icx",
	"id",
	"idai",
	"idex",
	"ieth",
	"ifarm",
	"ignis",
	"iknc",
	"ilink",
	"ilv",
	"imx",
	"inb",
	"inj",
	"ins",
	"instar",
	"iost",
	"iota",
	"iotx",
	"iq",
	"iq-2",
	"irep",
	"iris",
	"isai",
	"ist",
	"isusd",
	"iusdc",
	"iwbtc",
	"ixt",
	"izrx",
	"jnt",
	"jrt",
	"jst",
	"jto",
	"juno",
	"jup",
	"kas",
	"kava",
	"kcs",
	"kda",
	"keep",
	"key",
	"kick",
	"kin",
	"kira",
	"kiro",
	"kiwi",
	"klay",
	"klv",
	"kmd",
	"knc",
	"ksm",
	"ktn",
	"kub",
	"kuji",
	"lamb",
	"land",
	"lba",
	"lcx",
	"ldo",
	"lend",
	"leo",
	"lien",
	"link",
	"lit",
	"lky",
	"ln",
	"lode",
	"loki",
	"lon",
	"looks",
	"loom",
	"lpf",
	"lpt",
	"lqd",
	"lqty",
	"lrc",
	"lsk",
	"lss",
	"ltc",
	"lto",
	"luca",
	"lun",
	"luna",
	"lusd",
	"lxt",
	"lym",
	"m",
	"mSOL",
	"magic",
	"maha",
	"maid",
	"man",
	"mana",
	"manta",
	"mask",
	"math",
	"matic",
	"matter",
	"mav",
	"mbc",
	"mbox",
	"mc",
	"mcb",
	"mco",
	"mcx",
	"mda",
	"mdao",
	"mds",
	"med",
	"medx",
	"meme",
	"met",
	"metano",
	"meth",
	"metis",
	"mew",
	"mex",
	"mfg",
	"mft",
	"mim",
	"mimatic",
	"mina",
	"mir",
	"mith",
	"mkr",
	"mln",
	"mngo",
	"mnt",
	"mntl",
	"mnw",
	"mochi",
	"mod",
	"mom",
	"mon",
	"moons",
	"morpho",
	"mot",
	"mpl",
	"mta",
	"mth",
	"mtl",
	"mtn",
	"mura",
	"mvc",
	"mvl",
	"mvp",
	"mwat",
	"mwc",
	"mxc",
	"mxm",
	"myb",
	"myx",
	"nano",
	"nas",
	"nav",
	"ncash",
	"nct",
	"near",
	"nebl",
	"nec",
	"neo",
	"neox",
	"nest",
	"new",
	"nex",
	"nexo",
	"nexus",
	"nexxo",
	"nft",
	"nftb",
	"ngc",
	"night",
	"niox",
	"nkn",
	"nlg",
	"nmr",
	"noia",
	"nos",
	"not",
	"npc",
	"nper",
	"npxs",
	"nrg",
	"nrv",
	"nrve",
	"ntic",
	"ntl",
	"ntrn",
	"nu",
	"nuls",
	"nxm",
	"nxra",
	"nxs",
	"nxt",
	"oag",
	"oax",
	"ocean",
	"ocn",
	"ode",
	"ogn",
	"ohm",
	"oil",
	"okb",
	"oks",
	"olt",
	"omg",
	"ondo",
	"one",
	"onion",
	"ont",
	"op",
	"open",
	"opium",
	"opm",
	"opul",
	"opx",
	"orai",
	"orbs",
	"orc",
	"ordi",
	"orn",
	"osmo",
	"ost",
	"ovc",
	"ox",
	"oxt",
	"pBTC",
	"pai",
	"paint",
	"pal",
	"palm",
	"palm-2",
	"paper",
	"par",
	"part",
	"pasg",
	"pax",
	"paxg",
	"pay",
	"pbirb",
	"pbr",
	"pendle",
	"pepe",
	"perl",
	"perp",
	"pha",
	"phtk",
	"phx",
	"pickle",
	"pika",
	"pip",
	"pivx",
	"plDAI",
	"plUSDC",
	"pla",
	"play",
	"plr",
	"pltc",
	"pnb",
	"png",
	"pnk",
	"pnt",
	"poa",
	"poe",
	"pokt",
	"pols",
	"poly",
	"poly-2",
	"polyx",
	"pom",
	"pond",
	"pool",
	"pop",
	"popcat",
	"powr",
	"ppay",
	"ppc",
	"ppp",
	"ppt",
	"pre",
	"premia",
	"prime",
	"prl",
	"pro",
	"prom",
	"pros",
	"prq",
	"psp",
	"pst",
	"pxp",
	"pyr",
	"pyth",
	"pyusd",
	"qash",
	"qbit",
	"qi",
	"qkc",
	"qlc",
	"qnt",
	"qrdo",
	"qsp",
	"qtcon",
	"qtum",
	"quick",
	"r",
	"raca",
	"rae",
	"rai",
	"rain",
	"rari",
	"rave",
	"ray",
	"rbn",
	"rbx",
	"rcn",
	"rdai",
	"rdd",
	"rdn",
	"rdnt",
	"ren",
	"rep",
	"req",
	"reth",
	"reth-2",
	"rev",
	"rfox",
	"rfwsteth",
	"rgt",
	"rhoc",
	"rif",
	"rlc",
	"rly",
	"rndr",
	"ron",
	"rook",
	"rose",
	"rpl",
	"rpx",
	"rseth",
	"rsr",
	"rsv",
	"rune",
	"rvn",
	"s",
	"sai",
	"salt",
	"san",
	"sand",
	"sapp",
	"sar",
	"sats",
	"scrl",
	"scrt",
	"scs",
	"sdex",
	"sdl",
	"sdt",
	"seele",
	"sefi",
	"sei",
	"sem",
	"seth",
	"seth2",
	"sfi",
	"sfm",
	"sfp",
	"sfp-2",
	"sha",
	"shib",
	"shr",
	"shuf",
	"si",
	"sia",
	"sidus",
	"silo",
	"skl",
	"sky",
	"sky2",
	"sld",
	"slex",
	"slp",
	"slt",
	"smart",
	"snail",
	"snc",
	"sngls",
	"snm",
	"snt",
	"snx",
	"soaps",
	"socks",
	"sofi",
	"sol",
	"solch",
	"soul",
	"sov",
	"spank",
	"spike",
	"spn",
	"sqr",
	"srm",
	"ssv",
	"stable",
	"stablecoin",
	"stake",
	"steem",
	"step",
	"steth",
	"stg",
	"stmx",
	"sto",
	"storj",
	"storm",
	"stpt",
	"strat",
	"strdy",
	"strk",
	"strx",
	"stusds",
	"stx",
	"stz",
	"sub",
	"sui",
	"sun",
	"super",
	"suqa",
	"surge",
	"susd",
	"susd-2",
	"susde",
	"susds",
	"sushi",
	"suter",
	"swap",
	"sweat",
	"sweth",
	"swth",
	"sxdt",
	"sxp",
	"syn",
	"sys",
	"t",
	"tao",
	"tbtc",
	"tbtc-2",
	"tct",
	"tel",
	"tet",
	"tfuel",
	"thales",
	"thc",
	"thedao",
	"theta",
	"thr",
	"tia",
	"tio",
	"titan",
	"tkn",
	"tko",
	"tkx",
	"tky",
	"tnb",
	"tnc",
	"tnd",
	"tnt",
	"token",
	"tomi",
	"tomo",
	"ton",
	"torn",
	"tower",
	"tpay",
	"trac",
	"trb",
	"tribe",
	"trig",
	"trtl",
	"tru",
	"trx",
	"tryb",
	"ttc",
	"tube",
	"tusd",
	"twt",
	"tyzen",
	"ubi",
	"ubq",
	"ubt",
	"uft",
	"ult",
	"ult-2",
	"uma",
	"uncx",
	"unfi",
	"uni",
	"unibot",
	"uniqo",
	"unn",
	"uos",
	"upp",
	"usd1",
	"usdc",
	"usdd",
	"usde",
	"usdf",
	"usdg",
	"usdgo",
	"usdn",
	"usdp",
	"usds",
	"usdt",
	"usdt0",
	"usdy",
	"usdy2",
	"usr",
	"usx",
	"usyc",
	"utk",
	"uuu",
	"uxp",
	"vai",
	"valor",
	"value",
	"vekwenta",
	"vela",
	"velo",
	"veri",
	"vest",
	"vet",
	"vgx",
	"via",
	"vib",
	"vibe",
	"vidt",
	"vikky",
	"vin",
	"vina",
	"vita",
	"vite",
	"viu",
	"vlx",
	"vrs",
	"vs",
	"vsp",
	"vsys",
	"vtc",
	"vvs",
	"vvv",
	"w",
	"wabi",
	"wagmigames",
	"wallet",
	"wan",
	"warp",
	"wassie",
	"waves",
	"wbt",
	"wbtc",
	"wck",
	"wct",
	"weco",
	"weeth",
	"wemix",
	"weth",
	"wexpoly",
	"whale",
	"wib",
	"wild",
	"win",
	"wing",
	"wings",
	"wld",
	"wlfi",
	"wmt",
	"woo",
	"wopenx",
	"wpr",
	"wrx",
	"wsteth",
	"wtbt",
	"wtc",
	"wxt",
	"x2y2",
	"xai",
	"xas",
	"xaut",
	"xch",
	"xchf",
	"xcm",
	"xcn",
	"xdc",
	"xec",
	"xem",
	"xhv",
	"xido",
	"xin",
	"xlm",
	"xln",
	"xlq",
	"xmark",
	"xmr",
	"xmt",
	"xmx",
	"xnk",
	"xno",
	"xns",
	"xor",
	"xpl",
	"xpr",
	"xprt",
	"xrd",
	"xrgb",
	"xrp",
	"xsn",
	"xsr",
	"xtz",
	"xvg",
	"xym",
	"xyo",
	"xzc",
	"yara",
	"yfi",
	"yfii",
	"yld",
	"yoyo",
	"zai",
	"zano",
	"zb",
	"zco",
	"zec",
	"zel",
	"zen",
	"zeph",
	"zil",
	"zk",
	"zks",
	"zksp",
	"zpay",
	"zro",
	"zrx",
	"zusd",
]);

export const CUSTOM_COIN_ICONS = new Set<string>(["altcoin", "btc", "eth", "stablecoin"]);
